import { render, staticRenderFns } from "./DxStockTable.vue?vue&type=template&id=2f30d194&"
import script from "./DxStockTable.vue?vue&type=script&lang=js&"
export * from "./DxStockTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports